{
  "api": {
    "locationValidationTitle": "Chúng tôi không thể xác thực vị trí của bạn",
    "thresholdTitle": "Chưa đúng thời gian check-in",
    "warehouseUnavailableTitle": "Kho hàng không khả dụng",
    "warehouseUnavailableMessage": "Vui lòng liên hệ nhân viên cơ sở để tiến hành check-in thủ công",
    "characterLimitTitle": "Dữ liệu nhập vượt quá giới hạn ký tự",
    "genericTitle": "Check-in thất bại. Vui lòng thử lại.",
    "recaptchaTitle": "Xác minh thất bại",
    "recaptchaMessage": "Chúng tôi không thể xác minh yêu cầu của bạn. Vui lòng thử lại hoặc liên hệ nhân viên cơ sở."
  }
}
